<script>
    import locationsStore from "../stores/locationsStore";
    import {createEventDispatcher} from 'svelte';
    import {JSONClone, findNode, backPath} from "../lib/lib";
    //import GeoAutocomplete from "./GeoAutocomplete.svelte";
    //import CheckboxControl from '../controls/CheckboxControl.svelte';
    import {setFocusTo} from "../lib/lib";
    import {geoSave} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';

    const dispatch = createEventDispatcher();

    export let location;

    let editedLocation = null;
    let parentsPath = '';
    let geoTitle = '';

    const onClick = (event = null) => {
        if (editedLocation !== null) {
            return;
        }

        $locationsStore.selected_id = location.id;

        if (event && event.ctrlKey && location.children.length > 0) {
            onToggle();
        } else {
            dispatch('select', location);
        }
    }

    const onToggle = () => {
        if (location.children.length > 0) {
            location.expanded = !location.expanded;
        }
        $locationsStore.selected_id = location.id;
    }

    const onEdit = () => {
        dispatch('edit', location);
    }

    const onOpenMap = () => {
        let zoom = 12;
        if (location.level == 0) {
            zoom = 10;
        }
        window.open(`https://www.google.com/maps/@${location.latlng},${zoom}z`, '_blank').focus();
    }

    const onCancel = () => {
        if (editedLocation.id === 0) {
            // remove child from parent
            let parent = findNode(editedLocation.parent_id, $locationsStore.tree);
            parent.children = parent.children.filter(x => x.id !== editedLocation.id);
            $locationsStore.tree = $locationsStore.tree;
        }
        $locationsStore.edit_id = null;
        editedLocation = null;
    }

    const onSave = async () => {
        if (editedLocation.name === '') {
            app_alert.show('error', "Πληκτρολογήστε ένα όνομα για την περιοχή!");
            return;
        }

        // Parent has change
        let parent = null;
        if (location.parent_id !== editedLocation.parent_id) {
            // remove geo from parent
            parent = findNode(location.parent_id, $locationsStore.tree);
            parent.children = parent.children.filter(x => x.id !== location.id);
            // add geo on new parent
            parent = findNode(editedLocation.parent_id, $locationsStore.tree);
            parent.children = [...parent.children, editedLocation];
            editedLocation.level = parseInt(parent.level) + 1;
        }

        const [err, res] = await geoSave(editedLocation);

        if (err) {
            alert('error ' + err);
            return;
        }

        if (editedLocation.id === 0) {
            $locationsStore.last_agent_id = editedLocation.agent_id;
        }

        editedLocation.id = res.geo.id;
        location.id = editedLocation.id;
        location.name = editedLocation.name;
        location.parent_id = editedLocation.parent_id;
        location.agent_id = editedLocation.agent_id;
        location.description = editedLocation.description;
        location.level = editedLocation.level;
        location.latlng = editedLocation.latlng;
        location.deprecated = editedLocation.deprecated;
        $locationsStore.edit_id = null;
        editedLocation = null;
        $locationsStore.tree = $locationsStore.tree;
        $locationsStore.selected_id = location.id;

        success.show("Η περιοχή ενημερώθηκε.");
    }

    $:{
        // if (editedLocation === null && $locationsStore.edit_id === location.id) {
        //     editedLocation = JSONClone(location);
        //     setFocusTo('geo-name');
        // }

        if ($locationsStore.marked_id === location.id) {
            parentsPath = backPath(location.parent_id, $locationsStore.tree);
        } else {
            parentsPath = '';
        }

        geoTitle = "id: " + location.id + " - level: " +  location.level;
    }
</script>

<div class="node-group level-{ location.level }" id="location-item-{ location.id }" on:click="{ onClick }">
    <div class="node" class:selected={ location.id === $locationsStore.selected_id }>
        {#if location.children.length > 0}
            <div class="toggle" on:click|preventDefault|stopPropagation="{ onToggle }">
                {#if location.expanded}
                    <i class="fa fa-chevron-down"></i>
                {:else}
                    <i class="fa fa-chevron-right"></i>
                {/if}
            </div>
        {/if}
        {#if editedLocation !== null}
            <div class="edit-panel">
                <div class="edit-panel-heading">
                    {#if !editedLocation.name}
                        Νέα τοποθεσία
                    {:else}
                        { editedLocation.name }
                    {/if}
                </div>
                <div class="edit-panel-body">
                    <div class="row">
                        <div class="col-md-6">
                            <label>Id: { editedLocation.id > 0 ? editedLocation.id : 'ΝΕΟ' }</label>
                        </div>
                        <div class="col-md-6">
                            <label>Επίπεδο: { editedLocation.level }</label>
                        </div>
                    </div>
                    <hr style="margin-top: none">
                    <div class="form-group">
                        <label>Όνομα</label>
                        <input type="text" class="form-control" id="geo-name" bind:value="{ editedLocation.name }">
                    </div>
                    <!--{#if editedLocation.level > 1}-->
                    <!--    <div class="form-group">-->
                    <!--        <label>Μαμά</label>-->
                    <!--        <GeoAutocomplete bind:geoId="{ editedLocation.parent_id }" minLevel="2" maxLevel="4"/>-->
                    <!--    </div>-->
                    <!--{/if}-->
                    {#if editedLocation.level === 2}
                        <div class="form-group">
                            <label>Περιλαμβάνει τους δήμους</label>
                            <input type="text" class="form-control" bind:value="{ editedLocation.description }">
                        </div>
                    {/if}
                    <div class="form-group">
                        <label>Συντεταγμένες</label>
                        <input type="text" class="form-control" bind:value="{ editedLocation.latlng }">
                    </div>
                    <div class="text-right">
                        <button class="btn btn-primary btn-md" on:click="{ onSave }">Ενημέρωση</button>
                        <button class="btn btn-default btn-md" on:click="{ onCancel }">Ακύρωση</button>
                    </div>
                </div>
            </div>
        {:else}
            <div class="name" class:marked="{ $locationsStore.marked_id === location.id }">
                <span title="{ geoTitle }">
                    { location.name }
                </span>
                {#if ($locationsStore.selected_id === location.id || location.expanded) && location.description}
                    <div class="kalikratis-info">
                        { location.description }
                    </div>
                {/if}
                {#if parentsPath}
                    <div class="marked-path">
                        { parentsPath }
                    </div>
                {/if}
            </div>
            <div class="button" title="Επεξεργασία" on:click="{ onEdit }"><i class="fa fa-edit"></i></div>
            {#if location.latlng && location.latlng.length}
                <div class="button" title="Εμφάνιση σε google maps" on:click="{ onOpenMap }"><i class="fa fa-map-marker"></i></div>
            {/if}
        {/if}
    </div>

    {#if location.expanded}
        <div class="children">
            {#each location.children as child}
                <svelte:self location="{ child }"
                             on:cancel_edit
                             on:edit
                             on:select
                />
            {/each}
        </div>
    {/if}
</div>